
/* Define global variables */

const optionName_MasseLxB = 'Masse_LxB';
const optionName_CornerChoice = 'Auswahl für Eckenabrundung';
const optionName_CornerChoiceWindowsill = 'Fensterbank - Auswahl für Eckenabrundung';
const sideAlabel = 'A';
const sideBlabel = 'B';
const sideClabel = 'C';
const sideDlabel = 'D';

/* Define global helper functions */

function getMasseLxBinputElement(XorY) {
    let XorY_lc = XorY.toLowerCase();
    return document.querySelector('input[name="properties[_' + optionName_MasseLxB + '_' + XorY_lc + ']"]')
}

function getAusklinkungContainerElement() {
    let element = document.querySelector('div[data-option*="Ausklinkung Details"]');
}

/* Obeserve when user is changed something */

window.addEventListener('option:changed', function (e) {

    // e.detail contains the option reference
    var option = e.detail;

    // print the option to the console
    // console.debug('option changed', option);
    addOrHideSurfaceFinishingOptions();

    // check if the option is the one we want
    if (option.name == 'Anwendungszweck') {

        // console.log('Anwendungszweck changed', option);

        // check if the value is the one we want
        if (option.value == 'Tischplatte') {

        }
    }

    if (option.name == 'Ausklinkung Details') {

        // console.log('Ausklinkung Details changed', option);

        let ausklinkungContainerElem = document.querySelector('div[data-option*="Ausklinkung Details"] div.cl-po--swatch-container');

        if (option.value == 'Linke Seite') {
            // console.log('nur linke Seite');
            ausklinkungContainerElem.classList.add('left-side');
            ausklinkungContainerElem.classList.remove('right-side');

        } else if (option.value == 'Rechte Seite') {
            // console.log('nur rechte Seite');
            ausklinkungContainerElem.classList.add('right-side');
            ausklinkungContainerElem.classList.remove('left-side');

        } else if (option.value == 'Linke Seite,Rechte Seite') {
            // console.log('linke und Rechte Seite');
            ausklinkungContainerElem.classList.add('right-side');
            ausklinkungContainerElem.classList.add('left-side');

        } else {
            // console.log('ohne Ausklinkung');
            ausklinkungContainerElem.classList.remove('right-side');
            ausklinkungContainerElem.classList.remove('left-side');

        }

    }

    enableOrDisableAddToCartBtnIfNecessary(option);

});

function enableOrDisableAddToCartBtnIfNecessary(option) {
    // console.log('enableOrDisableAddToCartBtnIfNecessary ... option.name = ' + option.name);

    var addToCartBtn = document.querySelector('product-form.product-form button[name="add"]');
    
    var formOptionValue = '';
    var formOptionElement = document.querySelector('div[data-option="Form"]');
    if (formOptionElement) {
        formOptionValue = formOptionElement.querySelector('input:checked').value;
    }

    // console.log('formOptionValue: ' +  formOptionValue);

    if (option.name == 'Anwendungszweck') { 

        // if user chose any "Fensterbank", always activate button
        if (option.value.toLowerCase().startsWith('fensterbank')) {
            addToCartBtn.disabled = false;
            return;
        }

        // If user chose "Tischplatte, Ablage, Mauerabdeckung" ... 
        // if option-value of 'Form' is 'rund' or 'oval' --> hide add-to-cart button
        let optionValuesForDisable = ['rund', 'oval']
        if (optionValuesForDisable.includes(formOptionValue.toLowerCase())) {
            addToCartBtn.disabled = true;
            return;
        } else {
            addToCartBtn.disabled = false;
            return;
        }
    }
    
    // if user changes form, then enable or disable the checkout-button
    if (option.name == 'Form') {
        if (!addToCartBtn) {
            return;
        }
        // check if the value is the one we want
        addToCartBtn.disabled = (option.value != 'Rechteck');
    }
}

function enableOrDisableAddToCartBtnOnFormInputAppearance(selectedValue) {
    var addToCartBtn = document.querySelector('product-form.product-form button[name="add"]');
    if (!addToCartBtn) {
        return;
    }
    addToCartBtn.disabled = (selectedValue != 'Rechteck');
}

function addOrHideSurfaceFinishingOptions() {

    // // console.log('addOrHideSurfaceFinishingOptions ...');

    let allowedSurfaces = window.lpoAllowedSurfaceFinishings;
    if (!allowedSurfaces) {
        return; 
    }

    let surfaceOptionContainer = document.querySelector('[data-option="Oberfläche"] .cl-po--swatch-container');
    if (!surfaceOptionContainer) {
        return;
    }

    let surfaceOptionElements = surfaceOptionContainer.children;
    if (!surfaceOptionElements) {
        return;
    }

    for (let i = 0; i < surfaceOptionElements.length; i++) {
        let element = surfaceOptionElements[i];
        let elementInput = element.querySelector('input');

        if (!elementInput) {
            continue;
        }
        let optionValue = elementInput.value;

        if (allowedSurfaces.includes(optionValue)) {
            element.classList.remove('hidden');
        } else {
            element.classList.add('hidden');
        }
    }
}


/* integrate function(s) for mein-naturstein24.de */

window.addEventListener('options:rendered', function (e) {

    addOrHideSurfaceFinishingOptions();

    /* collabsible elements ******************************************************************** */

    window.toggleOptionsFields = function (self, fieldNames, action) {

        if (typeof fieldNames == 'undefined' || !(fieldNames)) {
            fieldNames = self.dataset['childOptions'];
        }

        let elmArr = fieldNames.split(";");

        if (typeof action == 'undefined') {
            action = self.classList.contains('collapsed') ? 'open' : 'close';
        }

        if (action == 'open') {
            self.classList.remove('collapsed');
            elmArr.forEach(function (fieldName, index) {
                let fieldNameQuery = '[data-option="' + fieldName + '"]';
                let foundElement = document.querySelectorAll(fieldNameQuery)[0];
                if (typeof foundElement != 'undefined') {
                    foundElement.classList.remove('hidden');
                }
            });

            // if action is 'open' close all other collapdible parents:
            // window.closeOtherCollapsibleElementsExept(self);
            return;
        }

        // else (action = close):
        self.classList.add('collapsed');
        elmArr.forEach(function (fieldName, index) {
            let fieldNameQuery = '[data-option="' + fieldName + '"]';
            let foundElement = document.querySelectorAll(fieldNameQuery)[0];
            if (typeof foundElement != 'undefined') {
                foundElement.classList.add('hidden');
            }
        });
    }

    /* deprecated - not used anymore */
    window.closeOtherCollapsibleElementsExept = function (self) {
        let allColapsibleParents = document.querySelectorAll(".option_group_separator_collapsible");
        allColapsibleParents.forEach(elem => {
            if (elem != self) {
                window.toggleOptionsFields(elem, false, 'close');
            }
        });
    }

    // initiate collapsible elments:
    const collapsibleElements = document.getElementsByClassName("option_group_separator_collapsible");
    for (let i = 0; i < collapsibleElements.length; i++) {
        // console.log(i);
        window.toggleOptionsFields(collapsibleElements[i], false, 'close');
    }

    /* Options-Change-Events ******************************************************************** */

    // declarare listener, when option is added to DOM

    window.optionDivNodeAddedListener = function (addedDivNode) {
        let dataOptionAttribute = addedDivNode.attributes['data-option'];
        if (typeof dataOptionAttribute == 'undefined') {
            return;
        }
        let addedOptionName = dataOptionAttribute.value;
        // console.log('div added. Option-Name: ' + addedOptionName);

        if (addedOptionName == 'Form') {
            let formSelectedInput = document.querySelector('input[name="properties[Form]"]:checked');
            if (typeof formSelectedInput != 'undefined') {
                enableOrDisableAddToCartBtnOnFormInputAppearance(formSelectedInput.value);
            }
        }

        // add labels for sides (only relevant for rectangular)
        let rectOptionNames = ["Kantenauswahl", "Untersicht schleifen - Kantenauswahl", optionName_CornerChoice];
        if (rectOptionNames.includes(addedOptionName)) {
            window.modifyRectForOption(addedOptionName);
            // add events to input fields for modifying rectengular:
            getMasseLxBinputElement('x').addEventListener('change', window.modifyAllRects);
            getMasseLxBinputElement('y').addEventListener('change', window.modifyAllRects);
        }

        // add front side label (only relevant for Ausklinkung)
        let windowSillRectOptionNames = ["Ausklinkung Details", optionName_CornerChoiceWindowsill];
        if (windowSillRectOptionNames.includes(addedOptionName)) {
            createFrontSideLabel(addedOptionName, 'Vorderseite');
        }
    };

    // observe, when new elements are added to live-product options:

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(mutation => {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {

                mutation.addedNodes.forEach(addedNode => {

                    if (addedNode.nodeName == 'DIV') {
                        window.optionDivNodeAddedListener(addedNode);
                    }

                });
            } else if (mutation.type == 'attributes' && mutation.target.nodeName == "INPUT") {
                // // console.log('input changed:');
                // // console.log(mutation);
                try {
                    window.inputFieldChanged(mutation.target.attributes.name.nodeValue, mutation.target.value);

                    /*
                    if (mutation.target.attributes.name.nodeValue == 'properties[Auswahl für Eckenabrundung]') {
                        // // console.log('new-value:' + mutation.target.value);
                    }
                    */
                } catch (error) {
                    // no worries. It's just the wrong html-node
                }
            }
        });
    });

    window.inputFieldChanged = function (nameAttribute, newInputValue) {
        // // console.log('input field value changed. input[name="[' + nameAttribute + '"]');
        // // console.log('new value = ' + newInputValue);
        if (nameAttribute == 'properties[' + optionName_CornerChoice + ']') {
            window.changeCornerRadiuses(newInputValue);
        }
        if (nameAttribute == 'properties[' + optionName_CornerChoiceWindowsill + ']') {
            window.changeCornerRadiusesWindowsill(newInputValue);
        }
    }

    observer.observe(document.querySelector('div.cl-po--wrapper'), { attributes: true, childList: true, characterData: false, subtree: true });

    /* scripts for adding or modifying width and length to edge-options */

    window.modifyAllRects = function () {
        window.modifyRectForOption(optionName_CornerChoice);
        window.modifyRectForOption("Kantenauswahl");
        window.modifyRectForOption("Untersicht schleifen - Kantenauswahl");
    }

    window.modifyRectForOption = function (optionName) {

        if (typeof optionName == 'undefined') {
            optionName = "Kantenauswahl";
        }

        // TODO: Validation: If one length is very big and the other very small, there must be a solution for that. This can be done via css (max-width and -height)

        // console.log('function modifyRectForKantenauswahl (' + optionName + ')...');

        // get data of width and length
        let rectWidth = getMasseLxBinputElement('x').value;
        let rectHeight = getMasseLxBinputElement('y').value;

        // console.log("Maße der Tischplatte: " + rectWidth + " x " + rectHeight);

        // normalize rectengular-size:
        let rectWidthNorm = 250;
        let rectHeightNorm = rectHeight * rectWidthNorm / rectWidth;

        // change variable.
        let root = document.querySelector(':root');
        root.style.setProperty('--edge-choice-side-width', rectWidthNorm + 'px');
        root.style.setProperty('--edge-choice-side-height', rectHeightNorm + 'px');

        /* create and modify elements for side-measurements */

        // get html-elements on top of rectangular (label for width)
        let rectLabelWidthElement = getRectLabelWidthElement(optionName);

        // get html-elements on top of rectangular (label for height)
        let rectLabelHeightElement = getRectLabelHeightElement(optionName);

        // set inner text of both rects:
        rectLabelWidthElement.innerHTML = rectWidth + " cm";
        rectLabelHeightElement.innerHTML = rectHeight + " cm";

        /* create and modify labels for sides (Seite A, B, C D) */
        // console.log("create labels ...");

        let sideLabelClassName = 'side-label-edge-choice';
        if (optionName == optionName_CornerChoice) {
            sideLabelClassName = 'side-label-corner-choice';
        }

        createRectSideLabel(optionName, 'side-a-label ' + sideLabelClassName, sideAlabel);
        createRectSideLabel(optionName, 'side-b-label ' + sideLabelClassName, sideBlabel);
        createRectSideLabel(optionName, 'side-c-label ' + sideLabelClassName, sideClabel);
        createRectSideLabel(optionName, 'side-d-label ' + sideLabelClassName, sideDlabel);

    }

    /* When value of Eckenabrundung is changed via click, proceed to the following function */

    window.changeCornerRadiuses = function (newInputValue) {
        // console.log('changeCornerRadiuses: ' + newInputValue);
        let newInputValueArr = newInputValue.split(",");

        let cornerTopLeft = false;
        let cornerTopRight = false;
        let cornerBottomRight = false;
        let cornerBottomLeft = false;

        newInputValueArr.forEach(myValue => {
            // console.log(myValue);
            if (myValue.trim() == 'Ecke A-B') cornerTopRight = true;
            if (myValue.trim() == 'Ecke B-C') cornerBottomRight = true;
            if (myValue.trim() == 'Ecke C-D') cornerBottomLeft = true;
            if (myValue.trim() == 'Ecke D-A') cornerTopLeft = true;
        });

        let root = document.querySelector(':root');
        root.style.setProperty('--corner-choice-top-left-active', cornerTopLeft ? '1' : '0');
        root.style.setProperty('--corner-choice-top-right-active', cornerTopRight ? '1' : '0');
        root.style.setProperty('--corner-choice-bottom-right-active', cornerBottomRight ? '1' : '0');
        root.style.setProperty('--corner-choice-bottom-left-active', cornerBottomLeft ? '1' : '0');
    }

    window.changeCornerRadiusesWindowsill = function (newInputValue) {
        // console.log('changeCornerRadiusesWindowsill: ' + newInputValue);
        let newInputValueArr = newInputValue.split(",");

        let cornerFrontLeft = false;
        let cornerFrontRight = false;

        newInputValueArr.forEach(myValue => {
            // console.log(myValue);
            if (myValue.trim() == 'Vorne links') cornerFrontLeft = true;
            if (myValue.trim() == 'Vorne rechts') cornerFrontRight = true;
        });

        let root = document.querySelector(':root');
        root.style.setProperty('--corner-choice-window-sill-front-left-active', cornerFrontLeft ? '1' : '0');
        root.style.setProperty('--corner-choice-window-sill-front-right-active', cornerFrontRight ? '1' : '0');

    }

    function getRectLabelWidthElement(optionName) {

        let rectLabelWidthId = optionName.replace(/\s/g, '') + 'Width';
        let rectLabelWidthElement = document.querySelector('div.rect-label-width#' + rectLabelWidthId);
        if (rectLabelWidthElement != null) return rectLabelWidthElement;

        // if not exists create element
        let additionalClassName = (optionName == optionName_CornerChoice) ? 'rect-label-width-corner-choice' : '';
        rectLabelWidthElement = document.createElement('div');
        rectLabelWidthElement.className = 'rect-label-width ' + additionalClassName;
        rectLabelWidthElement.id = rectLabelWidthId;

        // position element in dom
        var parentEl;
        if (optionName == optionName_CornerChoice) {
            parentEl = document.querySelector('div[data-option*="' + optionName + '"]');
        } else {
            parentEl = document.querySelector('div[data-option*="' + optionName + '"] .cl-po--swatch-container label:nth-child(2)');
        }

        if (parentEl != null) {
            parentEl.prepend(rectLabelWidthElement);
        }

        return rectLabelWidthElement;
    }

    function getRectLabelHeightElement(optionName) {

        let rectLabelHeightId = optionName.replace(/\s/g, '') + 'Height';
        let rectLabelHeightElement = document.querySelector('div.rect-label-height#' + rectLabelHeightId);
        if (rectLabelHeightElement != null) return rectLabelHeightElement;

        // if not exists create element
        let additionalClassName = (optionName == optionName_CornerChoice) ? 'rect-label-height-corner-choice' : '';
        rectLabelHeightElement = document.createElement('div');
        rectLabelHeightElement.className = 'rect-label-height ' + additionalClassName;
        rectLabelHeightElement.id = rectLabelHeightId;

        // position element in dom
        var parentEl;
        if (optionName == optionName_CornerChoice) {
            parentEl = document.querySelector('div[data-option*="' + optionName + '"] .cl-po--swatch-container');
        } else {
            parentEl = document.querySelector('div[data-option*="' + optionName + '"] .cl-po--swatch-container label:nth-child(4)');
        }

        if (parentEl != null) {
            parentEl.appendChild(rectLabelHeightElement);
        }

        return rectLabelHeightElement;
    }

    function createRectSideLabel(optionName, individualClassName, elementContent) {

        // create id and get elements
        let sideALabelId = optionName.replace(/\s/g, '') + 'SideALabel';
        let sideALabelElement = document.querySelector('div.' + individualClassName + '#' + sideALabelId);
        if (sideALabelElement != null) return;

        // if not exists create element
        sideALabelElement = document.createElement('div');
        sideALabelElement.className = 'side-label ' + individualClassName;
        sideALabelElement.id = sideALabelId;

        // set text of label
        sideALabelElement.innerHTML = elementContent;

        // position element in dom
        parentEl = document.querySelector('div[data-option*="' + optionName + '"] .cl-po--swatch-container');
        if (parentEl != null) {
            parentEl.appendChild(sideALabelElement);
        }

    }

    function createFrontSideLabel(optionName, elementContent) {

        let className = 'front-side-label';

        // create id and get elements
        let frontSideLabelId = optionName.replace(/\s/g, '') + 'FrontSideLabel';
        let frontSideLabelElement = document.querySelector('div.' + className + '#' + frontSideLabelId);
        if (frontSideLabelElement != null) return;

        // if not exists create element
        frontSideLabelElement = document.createElement('div');
        frontSideLabelElement.className = 'side-label ' + className;
        frontSideLabelElement.id = frontSideLabelId;

        // set text of label
        frontSideLabelElement.innerHTML = elementContent;

        // position element in dom
        parentEl = document.querySelector('div[data-option*="' + optionName + '"] .cl-po--swatch-container');
        if (parentEl != null) {
            parentEl.appendChild(frontSideLabelElement);
        }
    }

}, { once: true });